module.exports = __webpack_public_path__ + "static/img/buy_process@3x.037c7ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/buy_process@3x.png
// module id = 3f7A
// module chunks = 1